import React from 'react'

export default function Default({ BioData }) {
    return (
        <div>{JSON.stringify(BioData)}</div>
    )
}
